import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { givingEmbedUrl, givingUrl, withGivingAmount } from '../config';

interface ExternalGiveLinkProps {
  className?: string;
  children: ReactNode;
  onClick?: () => void;
  /** Suggested gift in whole dollars: pre-fills the Givebutter form. */
  amount?: number;
}

/**
 * The ONE Donate affordance (PRD 9.5).
 * - Givebutter campaign link (VITE_GIVEBUTTER_URL): leads to the embedded form on the
 *   Donate page (/store#give), so donors stay on the site.
 * - Any other giving URL: opens it in a new tab.
 * - Unset: the Donate page's tiers (/store#give).
 * `amount` travels as `?amount=` (Givebutter pre-fills it; other providers ignore it).
 */
export function ExternalGiveLink({ className, children, onClick, amount }: ExternalGiveLinkProps) {
  if (givingEmbedUrl || !givingUrl) {
    return (
      <Link to={`/store${amount ? `?amount=${amount}` : ''}#give`} className={className} onClick={onClick}>
        {children}
      </Link>
    );
  }
  return (
    <a href={withGivingAmount(givingUrl, amount)} target="_blank" rel="noopener noreferrer" className={className} onClick={onClick}>
      {children}
      <span className="sr-only"> (opens in a new tab)</span>
    </a>
  );
}
